import * as tslib_1 from "tslib";
import React from 'react';
import { getDeviationType } from '../../../_helpers';
import { DeviationTypes } from '../../../../types/deviation';
import OverlayContext from './OverlayContext';
import DesktopOverlayContent from './DesktopOverlayContent';
import { LoveMeter } from '../../../../LoveMeter';
import { LoveMeterContext } from '../../../../LoveMeter/LoveContext';
import { MobileOverlayContent } from './MobileOverlayContent';
import { withMobileContext } from '../../../../Context';
var Overlay = /** @class */ (function (_super) {
    tslib_1.__extends(Overlay, _super);
    function Overlay() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Overlay.prototype.render = function () {
        var _this = this;
        var _a = this.props, deviation = _a.deviation, _b = _a.showTitle, propShowTitle = _b === void 0 ? true : _b, width = _a.width, isMobile = _a.isMobile;
        var isSmall = width !== undefined && width < 250;
        var deviationType = getDeviationType(deviation);
        var canShowTitle = ![
            DeviationTypes.JOURNAL,
            DeviationTypes.LITERATURE,
            DeviationTypes.POLL,
        ].includes(deviationType);
        return (React.createElement(OverlayContext.Consumer, null, function (_a) {
            var _b = _a.showLoveControl, showLoveControl = _b === void 0 ? false : _b, _c = _a.showFaveControl, showFaveControl = _c === void 0 ? true : _c, _d = _a.showCommentControl, showCommentControl = _d === void 0 ? true : _d, _e = _a.showPermanentIconWhenFaved, showPermanentIconWhenFaved = _e === void 0 ? true : _e, _f = _a.showAuthor, showAuthor = _f === void 0 ? true : _f, _g = _a.showAuthorTooltip, showAuthorTooltip = _g === void 0 ? false : _g, _h = _a.showTitle, showTitle = _h === void 0 ? propShowTitle : _h, loveShouldFetchRecommendations = _a.loveShouldFetchRecommendations;
            return (React.createElement(LoveMeter, { itemId: deviation.deviationId, initialData: { loveScore: deviation.loveScore }, supportsRecommendations: loveShouldFetchRecommendations },
                React.createElement(LoveMeterContext.Consumer, null, function (_a) {
                    var isLoveInProgress = _a.isLoveInProgress;
                    var showMobileLayout = isMobile && showLoveControl;
                    var props = tslib_1.__assign({}, _this.props, { showAuthor: showAuthor,
                        showAuthorTooltip: showAuthorTooltip, showTitle: canShowTitle && showTitle, isSmall: isSmall,
                        showLoveControl: showLoveControl,
                        showPermanentIconWhenFaved: showPermanentIconWhenFaved,
                        showCommentControl: showCommentControl,
                        showFaveControl: showFaveControl,
                        isLoveInProgress: isLoveInProgress });
                    return showMobileLayout ? (React.createElement(MobileOverlayContent, tslib_1.__assign({}, props))) : (React.createElement(DesktopOverlayContent, tslib_1.__assign({}, props)));
                })));
        }));
    };
    return Overlay;
}(React.Component));
export default withMobileContext(Overlay);
//# sourceMappingURL=Overlay.js.map